import { Middleware } from '@reduxjs/toolkit';
import { io, Socket } from 'socket.io-client';
import { notificationActions } from '../slices/notificationSlice';

import { socketJobMetrics, socketJobPayload, socketJobAttachmentUpdate } from '../slices/jobSlice';

import {
  socketIndividualPayload,
  socketIndividualAttachmentUpdate,
} from '../slices/individualSlice';

import { Job, JobMetrics, Notification } from '../../types/interface';

// Websocket middleware: Used to handle incoming events dispatched by backend server.
// MiddleWare integration with RTK's Store: https://redux-toolkit.js.org/api/getDefaultMiddleware will help show how this file is linked to store.tsx

const notificationMiddleware: Middleware = (mwStore) => {
  let socket: Socket;

  return (next) => (action) => {
    const state = mwStore.getState();
    const isConnectionEsablished = socket === undefined && state.notification.isConnected;

    if (
      notificationActions.startConnecting.match(action) &&
      !isConnectionEsablished &&
      state.auth.token !== null
    ) {
      console.warn('establishing socket connection...');
      socket = io(process.env.REACT_APP_SERVER_URL, {
        withCredentials: true,
        auth: { token: state.auth.token },
      });
      mwStore.dispatch(notificationActions.connectionEstablished());

      socket.on('connect', () => {
        console.log('SocketIO connection established!');
        const engine = socket.io.engine;
        console.log('transport: ', engine.transport.name); // in most cases, prints "polling"

        //START: Defaulut socketIO events to listen to
        engine.once('upgrade', () => {
          // called when the transport is upgraded (i.e. from HTTP long-polling to WebSocket)
          console.log('Transport upgraded: ', engine.transport.name); // in most cases, prints "websocket"
        });
      });

      //START: Default socketIO events to listen to
      socket.on('disconnect', (reason: string) => {
        console.log('Socket disconnected: ', reason);
        if (reason === 'transport error') {
          socket.connect();
        }
      });

      socket.on('reconnect_error', (error: any) => {
        console.log('Socket reconnect error detected.');
        console.log(error);
      });

      socket.on('reconnect_attempt', (attempt: any) => {
        console.log(`reconnection to websockets attempted ${attempt} times`);
      });

      socket.on('connect_error', (error: any) => {
        console.log('SocketIO Connect Error!');
        console.log(error);
      });
      //END: Default socketIO events to listen to

      //Events which are passed, processed and stored in Redux Store
      socket.on('job', (res: { data: { isNew: boolean; job: Job[]; metrics: JobMetrics[] } }) => {
        console.info('job recieved, ', res);
        console.warn(state.individual.myId);
        mwStore.dispatch(
          socketJobPayload({
            isNew: res.data.isNew,
            job: res.data.job,
            metrics: res.data.metrics,
            userId: state.individual?.myId!,
          })
        );
      });

      socket.on('jobFileDel:update', (res: any) => {
        console.info('attachments event recieved, ', res);
        mwStore.dispatch(socketJobAttachmentUpdate(res));
      });

      socket.on('individualFileDel:update', (res: any) => {
        console.info('attachments event recieved, ', res);
        mwStore.dispatch(socketIndividualAttachmentUpdate(res));
      });

      socket.on('indv', (res: any) => {
        mwStore.dispatch(socketIndividualPayload(res));
      });

      socket.on('jMetric', (res: { ijMetrics: any; isNew: any }) => {
        mwStore.dispatch(
          socketJobMetrics({
            ijMetrics: res.ijMetrics,
            isNew: res.isNew,
            userId: state.individual?.myId!,
          })
        );
      });

      socket.on('connect_error', (err: { message: any }) => {
        console.log(err.message); // prints the message associated with the error
      });
    }
    next(action);
  };
};

export default notificationMiddleware;
